import classNames from 'classnames'

import {
  getSymbolCounterTextLength,
  isSymbolCounterLimitReached,
} from './SymbolCounter.utils'

import * as styles from './SymbolCounter.module.css'

function SymbolCounter({
  className = styles.SymbolCounter,
  getCurrentLength = getSymbolCounterTextLength,
  maxLength,
  value,
}) {
  const currentLength = getCurrentLength(value)

  const counterClassName = classNames(className, {
    [styles.limitReached]: isSymbolCounterLimitReached({
      currentLength,
      maxLength,
    }),
  })

  return (
    <span className={counterClassName}>{`${currentLength}/${maxLength}`}</span>
  )
}

export default SymbolCounter
